import type {
  TH2HPayment,
  TH2HPaymentCounts,
  TH2HPaymentCountsServer,
  TH2HPaymentServer,
  TH2HPaymentsResponse,
  TH2HPaymentsResponseServer,
} from '../store/types';

const h2hPaymentAdapter = (payment: TH2HPaymentServer): TH2HPayment => ({
  paymentId: payment.payment_id,
  created: payment.created,
  updated: payment.updated,
  workflowStatus: payment.workflow_status,
  baseAmount: payment.base_amount,
  baseCurrency: payment.base_currency,
  providerAmount: payment.provider_amount,
  providerCurrency: payment.provider_currency,
  paymentSystemName: payment.payment_system_name,
  remoteId: payment.remote_id,
  credentials: payment.credentials,
  payerId: payment.payer_id,
  shopId: payment.shop_id,
  shopName: payment.shop_name,
  methodId: payment.method_id,
  methodName: payment.method_name,
  ageSeconds: payment.age_seconds,
  slaDeadline: payment.sla_deadline,
  slaBreached: payment.sla_breached,
  clientCreditedAt: payment.client_credited_at,
  clientCreditedAmount: payment.client_credited_amount,
  merchantCallbackStatus: payment.merchant_callback_status,
  merchantCallbackIntentStatus: payment.merchant_callback_intent_status,
  merchantCallbackIntentPaidAmount: payment.merchant_callback_intent_paid_amount,
  merchantCallbackIntentReason: payment.merchant_callback_intent_reason,
  providerCallbackStatus: payment.provider_callback_status,
  providerCallbackReceivedAt: payment.provider_callback_received_at,
  settlementStatus: payment.settlement_status,
  settlementAmount: payment.settlement_amount,
  settlementCurrency: payment.settlement_currency,
  partnerShopId: payment.partner_shop_id,
  partnerCommission: payment.partner_commission,
  partnerCommissionCredited: payment.partner_commission_credited,
  rejectionReason: payment.rejection_reason,
  discrepancyReason: payment.discrepancy_reason,
  discrepancyReviewedAt: payment.discrepancy_reviewed_at,
  settlementSource: payment.settlement_source,
  availableActions: payment.available_actions,
});

export const h2hPaymentsAdapter = (response: TH2HPaymentsResponseServer): TH2HPaymentsResponse => ({
  count: response.count,
  items: response.items.map(h2hPaymentAdapter),
});

export const h2hPaymentCountsAdapter = (counts: TH2HPaymentCountsServer): TH2HPaymentCounts => ({
  actionRequired: counts.action_required,
  awaitingProvider: counts.awaiting_provider,
  discrepancies: counts.discrepancies,
  completed: counts.completed,
  rejected: counts.rejected,
  all: counts.all,
});
